import { inject, injectable } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';

type WalletMaxUsageSchema = {
  percentage: number;
};

@injectable()
class GetWalletMaxUsageConfigUseCase {
  @inject(WalletService) private walletService!: WalletService;

  async execute({ userUuid }: { userUuid: string }) {
    const response =
      await this.walletService.getWalletConfigBySlug<WalletMaxUsageSchema>({
        userUuid,
        slug: 'MAX_ORDER_ALLOWED_USAGE',
      });

    return response.data.schema;
  }
}

export default GetWalletMaxUsageConfigUseCase;
